import React from 'react';
import { connect } from 'react-redux';

import Items from '@components/items/Items.tsx';
import { s } from '@functions/seo.ts';
import { StoreT } from '@global/types.ts';

import checkPage from './methods/checkPage.ts';
import getArticlesItems from './methods/getArticlesItems.ts';
import getItems from './methods/getItems.ts';
import getScrollParent from './methods/getScrollParent.ts';
import loadingCallback from './methods/loadingCallback.ts';
import searchHandler from './methods/searchHandler.ts';

import BlogMainI from './types.ts';

import Menu from '../../../menu/Menu.tsx';
import renderArticle from './renders/renderArticle.tsx';
import renderContent from './renders/renderContent.tsx';
import renderHead from './renders/renderHead.tsx';
import renderSearch from './renders/renderSearch.tsx';

class BlogMain extends Items<BlogMainI['props'], BlogMainI['state']> implements BlogMainI {
    parent: BlogMainI['parent'];

    constructor(props: BlogMainI['props']) {
        super(props);

        const seoData = this.props.seoData;

        this.state = {
            search: '',
            sections: [],
            items: s() ? seoData.articles : undefined,
        };

        this.parent = React.createRef();
    }

    stepCounter = 12;
    classNameItem = '.publicBlog__article:not(._info)';

    getItems = getItems;
    getScrollParent = getScrollParent;
    getArticlesItems = getArticlesItems;
    loadingCallback = loadingCallback;
    searchHandler = searchHandler;
    checkPage = checkPage;

    renderArticle = renderArticle;
    renderHead = renderHead;
    renderSearch = renderSearch;
    renderContent = renderContent;

    componentDidMount() {
        this.checkPage();
    }

    componentDidUpdate() {
        this.checkPage();
    }

    render() {
        const { isReady, isLoadingFilter = false } = this.state;

        return (
            <>
                <div
                    className={`publicBlog _SECTION ${isReady && !isLoadingFilter ? '_ready' : ''}`}
                >
                    <div className="publicBlog__inner _col">
                        {this.renderHead()}
                        {this.renderContent()}
                    </div>
                </div>
                <div className="public__section _footer">
                    <Menu isFooter={true} />
                </div>
            </>
        );
    }
}

function mapStateToProps(state: StoreT) {
    return {
        device: state.device,
        levels: state.levels,
        seoData: state.seoData,
    };
}

export default connect(mapStateToProps)(BlogMain);
